document.addEventListener('DOMContentLoaded', function() {
  const tagsLinks = document.querySelectorAll('.js--tags_link');
if (tagsLinks.length) {
  tagsLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const anchor = this.getAttribute('href');
      const target = document.querySelector('.tags__item[data-anchor="' + anchor + '"]');
      const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 100;

      if (target) {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
}
});
